import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-code",
  "use": "icon-code-usage",
  "viewBox": "0 0 300 300",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 300 300\" overflow=\"visible\" id=\"icon-code\">\r\n<g>\r\n\t<path d=\"M282.52,63.62c-0.29-9.2-7.9-17.88-16.91-19.46c0,0-34.91-5.52-54.5-12.49c-24.46-8.71-48.67-27.84-48.67-27.84\r\n\t\tc-7.55-5.39-19.13-5.06-26.13,0.77c0,0-17.13,17.29-49.11,27.39C57.66,43.86,34.05,45.07,34.05,45.07\r\n\t\tc-8.91,1.16-16.58,9.38-16.75,18.58c0,0-1.22,47.27,0.31,88.76C18.18,226.63,106.04,300,150.44,300\r\n\t\tc43.7,0,119.23-51.12,131.11-146.51C284.48,96.86,282.52,63.62,282.52,63.62L282.52,63.62z M214.35,128.73l-75.54,76.46\r\n\t\tc-3.37,3.3-8.66,3.6-12.38,0.69l-39.45-31.35c-7.25-5.76-8.01-15.78-1.6-22.5c6.41-6.72,17.3-7.54,24.7-1.75l18.31,14.35\r\n\t\tl62.94-59.3c6.56-6.18,16.98-6,23.38,0.11c-0.09-0.09-0.12-0.22-0.21-0.32l0.53,0.54c-0.09-0.09-0.22-0.12-0.32-0.22\r\n\t\tC220.9,112.02,220.74,122.33,214.35,128.73L214.35,128.73z M214.35,128.73\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/code.svg
// module id = j8Uj
// module chunks = 34